import { SwipeableDrawer } from "@mui/material";
import type { JSX } from "react";
import SwipePuller from "@entrilia/shared/components/SwipePuller";

interface Props {
  open: boolean;
  onClose: () => void;
  children: JSX.Element | JSX.Element[];
}

const SwipeableBottomDrawer = ({ open, onClose, children }: Props) => {
  return (
    <SwipeableDrawer
      open={open}
      anchor="bottom"
      disableSwipeToOpen
      slotProps={{
        backdrop: { onClick: onClose },
      }}
      onClose={onClose}
      onOpen={() => undefined}
      swipeAreaWidth={20}
      sx={{
        zIndex: 1300,
        "& .MuiDrawer-paper": {
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        },
      }}
    >
      <SwipePuller />
      {children}
    </SwipeableDrawer>
  );
};

export default SwipeableBottomDrawer;
